import React from 'react'

import { useAPIGetPerencanaan } from 'api/kinerja/penilik-pegawai/perencanaan'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type {
  StatusPerencanaan,
  Perencanaan,
} from 'types/kinerja-penilik-pegawai'

type PerencanaanPSHooks = {
  perencanaan: Perencanaan
  apiStatus: string
  isPraktikKinerjaEditable: boolean
  isPengembanganKompetensiEditable: boolean
  isPerilakuKerjaEditable: boolean
}

const PERENCANAAN_NOT_FINALIZED_STATES: StatusPerencanaan[] = [
  'MULAI_PERENCANAAN',
  'SIAP_DIAJUKAN',
  'DIARAHKAN_REVISI_TK',
  'DIARAHKAN_REVISI_PPK',
]

export const usePerencanaanPenilik = (): PerencanaanPSHooks => {
  const { period, isHavePeriod } = usePeriodContext()
  const { data: perencanaan, status: apiStatus } = useAPIGetPerencanaan({
    periodId: period.id,
    enabled: isHavePeriod,
  })
  const isPraktikKinerjaEditable = React.useMemo(
    () =>
      PERENCANAAN_NOT_FINALIZED_STATES.includes(
        perencanaan?.praktikKinerjaStatus
      ),
    [perencanaan?.praktikKinerjaStatus]
  )
  const isPengembanganKompetensiEditable = React.useMemo(
    () =>
      PERENCANAAN_NOT_FINALIZED_STATES.includes(
        perencanaan?.pengembanganKompetensiStatus
      ),
    [perencanaan?.pengembanganKompetensiStatus]
  )
  const isPerilakuKerjaEditable = React.useMemo(
    () =>
      PERENCANAAN_NOT_FINALIZED_STATES.includes(
        perencanaan?.perilakuKerjaStatus
      ),
    [perencanaan?.perilakuKerjaStatus]
  )

  return {
    perencanaan,
    apiStatus,
    isPraktikKinerjaEditable,
    isPengembanganKompetensiEditable,
    isPerilakuKerjaEditable,
  }
}
